import { render, staticRenderFns } from "./gj-dropdown-item.vue?vue&type=template&id=60b22146&scoped=true&"
import script from "./gj-dropdown-item.vue?vue&type=script&lang=js&"
export * from "./gj-dropdown-item.vue?vue&type=script&lang=js&"
import style0 from "./gj-dropdown-item.vue?vue&type=style&index=0&id=60b22146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b22146",
  null
  
)

export default component.exports